import React, {PureComponent, Fragment} from 'react';
import {formatDate} from '../../utils/common';

import {Radio, List, InputItem, Toast, NoticeBar, WingBlank, WhiteSpace, Modal} from 'antd-mobile';

import PublicHeader from './../../components/header/index';

import {connect} from 'react-redux';
import {getPayParams, getOrderDetail, createOrderPage, createOrder} from './store/actionCreators';
import history from '../../utils/history';
import Action from './../action';
import './index.scss';
import {createForm} from 'rc-form';

const Item = List.Item;
const RadioItem = Radio.RadioItem;
const Brief = Item.Brief;
const alert = Modal.alert;

class Pay extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            disable: false,
            sendMessage: '获取验证码',
            time: 10,
            sendStatus: 0,
            payType: 3,
            memberName: "",
            phone: "",
            products: {}
        }
    }

    async componentDidMount() {
        const {products = {}} = this.props.location.state;
        console.log("products:", products)
        this.setState({
            products: products,
        });
        let oauthInfo = Storage.Base.getInstance().get('_loginTk');
        if (oauthInfo === null) {
            history.push('./login');
            return;
        }
        await this.props.createOrderPage(products);

        const orderDetail = this.props.orderDetail;
        const {memberDTO = {}} = orderDetail;

        if (memberDTO.isMember) {
            this.setState({
                payType: 1
            });
        }
        if (orderDetail.status != 1 || !orderDetail.canPay) {
            this.setState({
                disable: true
            });
        }
        this.setState({
            memberName: memberDTO.name,
            phone: orderDetail.phone,
        })
        // 监听浏览器点击返回
    }


    onChange = (value) => {
        this.setState({
            payType: value
        });
    };

    async handlePayOrder() {
        let oauthInfo = Storage.Base.getInstance().get('_loginTk');
        if (oauthInfo === null) {
            history.push('./login');
            return;
        }

        const {products = {}} = this.props.location.state;

        products.memberName = this.state.memberName;
        products.membnerPhone = this.state.phone.replace(/\s+/g, "");
        // 支付方式，0，微信支付|1.会员支付
        products.payType = this.state.payType;
        Toast.loading('支付中...', 10, () => {
            history.replace('/myOrder');
        });
        const result = await this.props.createOrder(products);

        console.log("order result:", result)
        if (result && result.data && result.data.status === 200) {
            if (!result.data.data.success) {
                Toast.hide();
                let error = result.data.data.error;
                alert('下单失败', error, [
                    {
                        text: '取消', onPress: () => {
                        history.replace('/home')
                    }
                    },
                    {
                        text: '确认', onPress: () => {
                        history.replace('/home')
                    }
                    },
                ])
                return;
            }
            if (products.payType === 1 || result.data.data.result.needNotPay) {
                Toast.success('支付成功');
                history.replace('/paySuccess');
            } else {
                window.WeChatPay.Base.getInstance().WeChatPay(result.data.data.result, this.HandlePayCallBack);
            }
        } else {
            Toast.info("下单异常!");
            history.replace('/myOrder');
        }
        Toast.hide();
    }

    HandlePayCallBack(res) {
        if (res.err_msg === "get_brand_wcpay_request:ok") {
            Toast.success('支付成功');
            history.replace('/paySuccess');
        }
        else {
            history.replace('/myOrder');
            Toast.success('支付已取消!');
        }
    }


    render() {
        const orderDetail = this.props.orderDetail;
        const {venueDTO = {}, siteDTO = {}, memberDTO = {}, payType = []} = orderDetail;

        return (
            <Fragment>
                <PublicHeader title="确认订单"/>

                <WhiteSpace size="sm" style={{background: "#F5F5F9"}}/>
                <WingBlank size="md" className="paycontent">
                    <List>
                        <Item extra={venueDTO.name}>
                            <div className="item-logo1" style={{marginTop: "2px"}}/>
                            <span style={{color: "#888"}}>预定场馆:</span>
                        </Item>
                    </List>
                </WingBlank>
                <WhiteSpace size="sm" style={{background: "#F5F5F9"}}/>
                <WingBlank size="md" className="paycontent">
                    <List renderHeader={() => <>
                    <div className="item-logo1"/>
                    预定场地:</>}>
                        <Item
                            extra={orderDetail.price / 100 + '元'}
                            multipleLine
                        >
                            <Brief>{siteDTO.name} {formatDate(orderDetail.beginTime, "yyyy-MM-dd")}
                            </Brief>
                            <Brief>
                                {formatDate(orderDetail.beginTime, "HH:mm:ss")}
                                - {formatDate(orderDetail.endTime, "HH:mm:ss")}
                            </Brief>
                        </Item>
                    </List>
                </WingBlank>
                <WhiteSpace size="sm" style={{background: "#F5F5F9"}}/>
                <WingBlank size="md" className="paycontent">
                    {!memberDTO.isMember ?
                        <List renderHeader={() => <>
                        <div className="item-logo1"/>
                        预定人信息</>}>
                            <InputItem
                                clear
                                placeholder="请输入联系人"
                                value={this.state.memberName}
                                style={{textAlign: "right"}}
                                onChange={(v) => {
                                    this.setState({memberName: v});
                                }}
                                maxLength="50"
                                className="am-list-content"
                            >
                                <span style={{color: "#888", fontSize: "14px"}}>联系人:</span>
                            </InputItem>
                            <InputItem
                                clear
                                placeholder="请输入手机号"
                                type="phone"
                                value={this.state.phone}
                                style={{textAlign: "right"}}
                                onChange={(v) => {
                                    this.setState({phone: v});
                                }}
                                className="am-list-content"
                            >
                                <span style={{color: "#888", fontSize: "14px"}}>手机号:</span>
                            </InputItem>

                        </List>
                        :
                        <List renderHeader={() => <>
                        <div className="item-logo1"/>
                        预定人信息</>}>
                            <Item extra={this.state.memberName}>
                                <span style={{color: "#888"}}>联系人:</span>
                            </Item>
                            <Item extra={this.state.phone}>
                                <span style={{color: "#888"}}>手机号:</span>
                            </Item>
                        </List>
                    }
                    <WhiteSpace size="sm" style={{background: "#F5F5F9"}}/>
                    <List renderHeader={() => <>
                    <div className="item-logo1"/>
                    支付渠道</>}>
                        {payType.map(i => (
                            <>{i.payType === 3 ? <div class="wx-logo"></div> : ""}
                            <RadioItem key={i.payType}
                                       checked={this.state.payType === i.payType}
                                       onChange={() => this.onChange(i.payType)}>
                                <span style={{color: "#888"}}>  {i.payDesc}</span>
                            </RadioItem>
                            </>
                        ))}
                    </List>

                </WingBlank>
                {!memberDTO.isMember ? "" :
                    orderDetail.canPay ? "" :
                        <NoticeBar mode="link"
                                   action={<span onClick={() => {
                                       history.push("/home")
                                   }}></span>}>
                            会员卡余额不足，请联系客服充值。
                        </NoticeBar>
                }
                <Action text="立即支付" disable={this.state.disable} price={orderDetail.price / 100}
                        HandleSubmitOrder={() => {
                            this.handlePayOrder()
                        }}/>
            </Fragment>
        )
    }
}

const mapStateToProps = (data) => {
    return {
        orderDetail: data.pay.orderDetail
    }
};

const mapDispatchToProps = (dispatch) => ({
    getOrderDetail: (orderId, id) => dispatch(getOrderDetail({orderId: orderId, userId: id})),
    handleWechatPay: (data, payType, orderId, userId, memberName, phone) => dispatch(getPayParams({
        payType: payType,
        orderId: orderId,
        payMethod: 'WeChatJs',
        userId: userId,
        memberName: memberName,
        phone: phone
    })),
    createOrderPage: (param) => dispatch(createOrderPage(param)),
    createOrder: (param) => dispatch(createOrder(param)),


});

const PayForm = createForm()(Pay);
export default connect(mapStateToProps, mapDispatchToProps)(PayForm);
